/* eslint-disable @typescript-eslint/no-var-requires, import/no-commonjs */
import * as React from 'react';
import { VirtualTourJsonType } from '@bb/domain/dist/types';
import StepHeaders from '../StepHeaders';
import VtGuestsForm from './VtGuestsForm';

const styles = require('../appointment_book.module.scss');

interface VtStep3InviteGuestsProps {
  currentStep?: number;
  updateState: (draft: Record<string, any>) => void;
  selectedTour?: VirtualTourJsonType;
}

const VtStep3InviteGuests: React.FC<VtStep3InviteGuestsProps> = ({
  currentStep = 2,
  updateState,
  selectedTour,
}) => (
  <div
    className={`col-md-3 ${
      currentStep === 2 ? styles.stepActive : styles.stepInactive
    }`}
  >
    <StepHeaders stepNumber={2} stepTitle="Invite Guests" />
    <VtGuestsForm updateState={updateState} selectedTour={selectedTour} />
  </div>
);

export default VtStep3InviteGuests;
